import { memo } from 'react';
import { t } from 'i18next';
import { Stack } from '@mui/system';
import { Divider } from '@mui/material';

import { Accordion } from '@common/components/Accordion';

import Appearance from './obstacle/Appearance';
import Height from './obstacle/Height';
import { ObstacleDimensions } from './ObstacleDimensions';

function ObstacleParametersComponent() {
  return (
    <Stack spacing={1} divider={<Divider />}>
      <ObstacleDimensions />
      <Accordion
        title={t<string>('interface:properties.obstacle.obstacle_title', 'Obstacle')}
        unmountOnExit
        defaultExpanded
        sx={{ px: 2 }}
      >
        <Stack direction='column' spacing={1} pb={2}>
          <Appearance />
          <Height />
        </Stack>
      </Accordion>
    </Stack>
  );
}

export const ObstacleParameters = memo(ObstacleParametersComponent);
